module.exports = __webpack_public_path__ + "static/rappi-3-f57fa0396ddb34052ceb480abe5674a5.jpg";